import { render, staticRenderFns } from "./DocumentCreateVersion.vue?vue&type=template&id=ddb319a0&"
import script from "./DocumentCreateVersion.vue?vue&type=script&lang=js&"
export * from "./DocumentCreateVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports